import { Page } from '@/core/architecture'

import { PostDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PostDetail Page
 * Implemented as a practical sample.
 */
export const PostDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <PostDetailTemplate state={state} {...actions} />
}
